import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot} from '@angular/router';
import {BreadCrumbAndDataResolverService} from '../../utilities/services/route-resolvers/bread-crumb-and-data-resolver.service';
import {BreadCrumbAndDataHelperService} from '../../utilities/services/route-resolvers/bread-crumb-and-data-helper.service';
import {ReportTemplateService} from '../services/report-template/report-template.service';
import {ReportTemplate} from '../interfaces/ReportTemplate';

@Injectable()
export class ReportEditNameResolverService extends BreadCrumbAndDataResolverService<ReportTemplate> {
  constructor(private reportService: ReportTemplateService, helper: BreadCrumbAndDataHelperService) {
    super(helper);
  }

  public async getData(route: ActivatedRouteSnapshot): Promise<ReportTemplate> {
    return await this.reportService.getReport(Number(route.params.id));
  }

  public getName(data: ReportTemplate): string {
    return `Edit ${data.name}`;
  }

}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/report/resolvers/report-edit-name-resolver.service.ts